/* eslint-disable no-shadow */
import {
    call, takeEvery
} from "redux-saga/effects";
import noop from "lodash.noop";

import {
    LOAD_REQUESTED, failLoadactionlist, successLoadactionlist
} from "./actionlist.duck";

import {
    loadActions,
} from "./actionlist.api";

import { getId, injectApiWithContextFactory, injectBoundActionCreatorsFactory, withRefreshRequest } from "Utils/sagaUtils";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        failLoadactionlist, successLoadactionlist
    },
    getId,
    "dashboardActionList"
);

export const withApiContext = injectApiWithContextFactory(
    { 
        loadActions
    }
);

export function* loadActionlistSaga({
    data, actions: { failLoadactionlist, successLoadactionlist }, api: { loadActions }, resolve = noop, reject = noop
}){
    try {
        const result = yield loadActions(data);
        const { fulfilled: { edges: r1 }, pending: { edges: r2 } } = result;
        const data = [ ...r1, ...r2 ].map(({ node }) => node);
        yield successLoadactionlist(data);
        yield call(resolve);
    } catch (e){
        console.log("ERROR", e);
        yield failLoadactionlist(e);
        yield call(reject, e);
    }
}

export default () => function* rootSaga() {
    yield takeEvery(LOAD_REQUESTED, withRefreshRequest(withBoundActions(withApiContext(loadActionlistSaga)), 1000 * 60));
};
